<div class="bloco-unico">
    <h3 class="uppercase">Rat</h3>
    <hr>
    <div class="table-responsive" *ngIf="pedido?.rat && pedido?.rat.length > 0">
      <table class="table">
        <thead>
          <tr>
            <th>RAT</th>
            <th>Documento</th>
            <th>Origem</th>
            <th>Tipo</th>
            <th>Data Início</th>
            <th>Data Fim</th>
            <th>Situação</th>
            <th>Código Externo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ratItem of pedido?.rat">
            <td>{{ratItem.ratID}}</td>
            <td>{{ratItem.documento}}</td>
            <td>{{ratItem.origem}}</td>
            <td>{{ratItem.tipo}}</td>
            <td>{{ratItem.dataInicio | date: "dd/MM/yyyy - HH:mm:ss" }} </td>
            <td>{{ratItem.dataFim | date: "dd/MM/yyyy - HH:mm:ss" }}</td>
            <td>{{ratItem.situacao}}</td>
            <td>{{ratItem.codigoExterno}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="!pedido?.rat || pedido?.rat.length == 0" style="min-height: 100px" class="d-flex justify-content-center align-items-center">
        <strong>Não há informação a ser exibida!</strong>
    </div>
  </div>
